export enum Manufacturer {
  Resmed = 'Resmed',
  PhilipsRespironics = 'Philips Respironics',
  FisherPaykel = 'Fisher & Paykel',
  Löwenstein = 'Löwenstein',
  BMC = 'BMC',
  Other = 'Other',
}
